<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="isodate"
    offset-y
    min-width="auto"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
        :dense="dense"
        :disabled="disabled"
        :placeholder="placeholder"
        :rules="rules"
        :value="date"
        outlined
        readonly
        prepend-inner-icon="mdi-calendar"
      ></v-text-field>
    </template>

    <v-date-picker
      v-model="isodate"
      no-title
      scrollable
      :max="max"
      :min="min"
      :readonly="readonly"
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        {{ $t("commons.cancel") }}
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="save"
        :disabled="!isodate"
      >
        {{ $t("commons.ok") }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { toDate, toISODate, stringToDate } from "@/utils/datetime"
export default {
  name: "DateInput",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    max: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isodate: "",
      menu: false
    }
  },
  computed: {
    date() {
      return toDate(this.value)
    }
  },
  methods: {
    save() {
      this.$refs.menu.save(this.isodate)
      this.$emit("input", stringToDate(this.isodate))
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.isodate = toISODate(newValue)
        }
      }
    }
  }
}
</script>
